<template>
  <div class="app-container">
    <div class="filter-container mb-4 flex flex-col" style="gap: 8px">
      <div class="flex flex-ac flex-wrap" style="flex: 1; min-width: 0">
        <div class="flex flex-wrap flex-ac" style="gap: 8px">
          <span class="flex flex-ac text-nowrap">年份筛选：</span>
          <el-select
            v-model="listQuery.tax_year"
            placeholder="选择年份"
            @change="handleFilter"
            class="filter-item"
            style="min-width: 120px"
          >
            <el-option
              v-for="item in years"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="listQuery.uuid"
            placeholder="请输入UUID"
            style="width: 200px; min-width: 150px"
            class="filter-item"
            clearable
          />
          <el-input
            v-model="listQuery.username"
            placeholder="请输入用户名称"
            style="width: 200px; min-width: 150px"
            class="filter-item"
            clearable
          />
          <el-select
            v-model="listQuery.submit_status"
            placeholder="状态"
            clearable
            style="width: 200px; min-width: 120px"
            class="filter-item"
          >
            <el-option label="未提交" value="0" />
            <el-option label="已提交" value="1" />
          </el-select>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
            >搜索</el-button
          >
        </div>
      </div>
      <span class="mt-2 md:mt-0 text-nowrap">
        年度周期：&nbsp; {{ getPreviousYear(listQuery.tax_year) }}年12月1日至{{
          listQuery.tax_year
        }}年11月30日
      </span>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      empty-text="暂无达标会员(奖金≥$600)"
    >
      <el-table-column label="用户名称" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.username || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="用户UUID" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.uuid || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="是否提交1099税表" min-width="140" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.submit_status > 0" type="success"
            >已提交</el-tag
          >
          <el-tag v-else type="info">未提交</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="当年总奖金数" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_bonus ?? '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        min-width="130"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <div class="gap">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.files.length < 1"
              @click="open1099Form(scope.row)"
            >
              上传 1099 表格
            </el-button>
            <el-button
              v-if="scope.row.files.length > 0"
              size="mini"
              @click="view1099Form(scope.row)"
            >
              在线查看
            </el-button>
            <el-button
              v-if="scope.row.files.length > 0"
              size="mini"
              type="success"
              @click="download1099Form(scope.row)"
            >
              下载
            </el-button>
            <el-button
              v-if="scope.row.files.length > 0"
              size="mini"
              type="warning"
              @click="open1099Form(scope.row)"
            >
              重新上传
            </el-button>
            <el-button
              v-if="scope.row.files.length > 0"
              size="mini"
              type="danger"
              @click="delete1099Form(scope.row)"
            >
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 上传1099表格弹窗 -->
    <el-dialog
      title="上传 1099 表格"
      :visible.sync="dialog1099FormVisible"
      width="500px"
      @close="handleDialog1099Close"
    >
      <div v-if="currentRow" class="form-info">
        <p><strong>用户信息</strong></p>
        <p>用户名：{{ currentRow.username }} ({{ currentRow.uuid }})</p>
        <p>年度：{{ listQuery.tax_year }}</p>
      </div>

      <el-upload
        ref="upload1099"
        class="upload-demo"
        drag
        action="#"
        :auto-upload="false"
        :http-request="upload1099Request"
        :before-upload="before1099Upload"
        :on-change="handle1099FileChange"
        :on-success="handle1099Success"
        :on-exceed="handle1099Exceed"
        :on-remove="handleRemove"
        :limit="1"
        :file-list="fileList"
        accept=".pdf,.png,.jpeg,.jpg"
        :multiple="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传文件</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          支持 PDF, PNG, JPEG, JPG 格式（Max 5MB）
        </div>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog1099FormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="uploading"
          :disabled="!fileList.length"
          @click="submit1099Form"
        >
          上 传
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getUploadPresignedUrl } from '@/api/common'

export default {
  name: 'Tax1099Report',
  data() {
    return {
      listObj: {},
      value: [],
      years: [],
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        username: '',
        uuid: '',
        submitted_1099: undefined,
        tax_year: '',
      },
      dialog1099FormVisible: false,
      currentRow: null,
      fileList: [],
      uploading: false,
    }
  },
  created() {
    this.getyearslist()
  },
  methods: {
    getyearslist() {
      this.listLoading = true
      request({
        url: '/api/backend/userTaxForm/taxYears',
        method: 'get',
      }).then((res) => {
        this.listQuery.tax_year =
          res.data.current_year || this.listQuery.tax_year
        this.years = res.data.years || []
        this.getList()
      })
    },
    getPreviousYear(year) {
      const currentYear = parseInt(year, 10)
      if (isNaN(currentYear)) {
        return year
      }
      return currentYear - 1
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/userTaxForm/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          this.list = response.data.data || []
          this.total = response.data.total || 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleFilter(e) {
      console.log(e)

      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    open1099Form(row) {
      this.currentRow = row
      this.fileList = []
      this.listObj = {}
      this.value = []
      this.dialog1099FormVisible = true
    },
    handle1099FileChange(file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    handle1099Exceed() {
      this.$message.warning('只能上传一个文件')
    },
    before1099Upload(file) {
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过 5MB')
        return false
      }

      const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('仅支持 PDF, PNG, JPEG, JPG 格式')
        return false
      }

      this.listObj[file.uid] = {
        hasSuccess: false,
        uid: file.uid,
        file_name: file.name,
        file_path: '',
        file_type: file.type,
        file_size: file.size,
      }

      return true
    },
    handleRemove(file) {
      const uid = file.uid

      this.value = this.value.filter((item) => item.uid !== uid)

      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    async upload1099Request(option) {
      const file = option.file

      if (!file) {
        this.$message.error('获取文件信息失败')
        option.onError(new Error('获取文件信息失败'))
        return
      }

      try {
        const folder = process.env.NODE_ENV + '/'
        const fileKey = folder + file.name

        // 1. 从后端获取预签名 URL
        const res = await getUploadPresignedUrl({
          file_name: fileKey,
          mime_type: file.type,
        })
        const { upload_url, key } = res.data

        // 2. 直接 PUT 到预签名 URL
        const uploadRes = await fetch(upload_url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
            'Content-Disposition': 'inline',
          },
        })

        if (!uploadRes.ok) {
          throw new Error('上传失败')
        }

        // 3. 触发 on-success 回调
        option.onSuccess({ key: key }, file)
      } catch (error) {
        console.error('上传失败', error)
        this.$message.error('上传失败，请重试')
        option.onError(error)
      }
    },
    submit1099Form() {
      this.uploading = true
      this.$refs.upload1099.submit()
    },
    handle1099Success(response, file) {
      console.log(response, file)

      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)

      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          const fileUrl = process.env.VUE_APP_AWS_S3_DOMAIN + response.key
          this.listObj[objKeyArr[i]] = {
            ...this.listObj[objKeyArr[i]],
            ...file,
            hasSuccess: true,
            file_name: file.name,
            file_path: response.key,
            file_type: file.raw ? file.raw.type : file.type,
            file_size: file.size,
            url: fileUrl,
          }
        }
      }

      this.value = Object.keys(this.listObj)
        .map((key) => this.listObj[key])
        .filter((item) => item.hasSuccess)

      const files = this.processFileUrls(this.value).map((item) => ({
        ...item,
        file_name: item.file_name,
        file_path: item.file_path,
        file_type: item.file_type,
        file_size: item.file_size,
      }))

      request({
        url: '/api/backend/userTaxForm/upload',
        method: 'post',
        data: {
          user_id: this.currentRow.id,
          tax_year: this.listQuery.tax_year,
          files: files,
        },
      })
        .then(() => {
          this.$message.success('1099表格上传成功')
          this.uploading = false
          this.dialog1099FormVisible = false
          this.getList()
        })
        .finally(() => {
          this.uploading = false
        })
    },
    processFileUrls(fileList) {
      const basePath = process.env.VUE_APP_AWS_S3_DOMAIN

      return fileList.map((file) => {
        if (file && file.file_path && file.file_path.includes(basePath)) {
          return {
            ...file,
            file_path: file.file_path.replace(basePath, ''),
          }
        }

        if (file && file.url && file.url.includes(basePath)) {
          return {
            ...file,
            file_path: file.url.replace(basePath, ''),
          }
        }

        return file
      })
    },
    handleDialog1099Close() {
      this.fileList = []
      this.currentRow = null
      this.listObj = {}
      this.value = []
      this.$refs.upload1099 && this.$refs.upload1099.clearFiles()
    },
    getYearValue() {
      return this.listQuery.tax_year instanceof Date
        ? this.listQuery.tax_year.getFullYear().toString()
        : String(this.listQuery.tax_year)
    },
    async view1099Form(row) {
      if (row.files && row.files.length > 0) {
        const file = row.files[0]
        if (file.file_url) {
          window.open(file.file_url, '_blank')
        } else {
          this.$message.error('未找到文件链接')
        }
      } else {
        this.$message.warning('没有可查看的文件')
      }
    },
    async download1099Form(row) {
      if (row.files && row.files.length > 0) {
        const file = row.files[0]
        if (file.file_url) {
          const response = await fetch(file.file_url)
          const blob = await response.blob()
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = file.file_name || '1099_form'
          document.body.appendChild(link)
          link.click()
          link.remove()
        } else {
          this.$message.error('未找到文件链接')
        }
      } else {
        this.$message.warning('没有可下载的文件')
      }
    },
    delete1099Form(row) {
      this.$confirm('确定要删除该1099表格吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/userTaxForm/delete',
            method: 'post',
            data: {
              user_id: row.id,
              tax_year: this.listQuery.tax_year,
            },
          })
            .then(() => {
              this.$message.success('1099表格删除成功')
              this.getList()
            })
            .catch(() => {
              this.$message.error('删除失败，请重试')
            })
        })
        .catch(() => {
          // 用户取消删除
          this.$message.info('已取消删除')
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

.form-info {
  margin-bottom: 20px;
  p {
    margin: 8px 0;
    font-size: 14px;
  }
  strong {
    font-weight: 600;
  }
}

.upload-demo {
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ml-auto {
  margin-left: auto;
}
.gap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
</style>
